<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import '../static/css/index.css'
export default {
  name: 'App'
}
</script>


<style>
body{padding:0px;margin:0px;background:#f3f3f3;margin-top: 70px!important;}
#app{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;margin:0px;padding:0px; -webkit-user-select: text!important;user-select: text!important;}
.el-menu .el-submenu__title{padding:0 10px;}
.el-menu-item{text-align:center;}
.el-menu-item a{color:#909399;}
a{text-decoration:none;}
.tabs .el-tabs__active-bar{height:4px;}
.tab .el-tabs__active-bar{height:4px;}
.el-menu--popup{min-width:100px!important;}
.nav_right .el-menu--horizontal>.el-submenu .el-submenu__title{height:70px;line-height: 70px;
color: #333;}
.el-menu--horizontal>.el-submenu .el-submenu__title{color:#333;}
.nav_right .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{border-bottom:4px solid #F51F1F!important;}
</style>



// WEBPACK FOOTER //
// src/App.vue